import type { VoidFunctionComponent } from 'react';

import { icons, IconText } from '../Icon';
import type { IconTextProps } from '../Icon/IconText';

import Link from './Link';
import type { LinkProps } from './Link';

type ExternalLinkProps = LinkProps & Pick<IconTextProps, 'alignIcon'>;

const getBaseUrl = (url: string) => {
  try {
    const urlObj = new URL(url);
    return urlObj.origin;
  } catch {
    return url;
  }
};

/**
 * Returns a link to an external URL with an icon indicating it's external.
 * It only shows the origin of the URL and not the full path, ie https://fossa.com/issues/whatever turns into fossa.com,
 * while still linking to the full URL.
 */
const ExternalLink: VoidFunctionComponent<ExternalLinkProps> = (props) => {
  return (
    <Link
      {...props}
      to={props.to}
    >
      <IconText icon={icons.externalLink} text={getBaseUrl(props.to)} alignIcon={props.alignIcon} />
    </Link>
  );
};

export default ExternalLink;
